export const ROLE_ROUTE_NAMES = ['abiturient', 'college'/*, 'department'*/];

export const ROLE_HOME_ROUTES = {
	abiturient: 'abiturient-home',
	college: 'places',
	// department: 'main',
};

export function getRoleHomeRouteName(role) {
	return ROLE_HOME_ROUTES[role] || null;
}

export function shouldRestoreReturnUrl(role) {
	return role !== 'abiturient';
}

export function getLoginReturnPath(path, role) {
	if (!path || !shouldRestoreReturnUrl(role)) {
		return null;
	}
	return path;
}

export function getRoleSectionName(route) {
	const match = route.matched.find(record => ROLE_ROUTE_NAMES.includes(record.name));
	return match ? match.name : null;
}

export function isPublicRoute(route) {
	return route.matched.some(record => record.meta && record.meta.public);
}

export function buildLoginPath(sectionName) {
	if (sectionName && ROLE_ROUTE_NAMES.includes(sectionName)) {
		return '/login/' + sectionName;
	}
	return '/login';
}

export function buildLoginHashUrl(returnPath, sectionName) {
	const loginPath = buildLoginPath(sectionName);
	const query = returnPath ? '?url=' + encodeURIComponent(returnPath) : '';
	return '/portal/#' + loginPath + query;
}

export function isValidReturnUrl(url, role) {
	if (!url || typeof url !== 'string' || !url.startsWith('/') || url.startsWith('//')) {
		return false;
	}
	if (!ROLE_ROUTE_NAMES.includes(role)) {
		return false;
	}
	if (!shouldRestoreReturnUrl(role)) {
		return false;
	}
	return url === '/' + role || url.startsWith('/' + role + '/');
}

export function getDefaultRouteForRole(role) {
	return ROLE_ROUTE_NAMES.includes(role) ? '/' + role : '/login';
}
